module.exports = __webpack_public_path__ + "img/success.bbf32cfb.png";